import { render } from "./ProfileVKEdit.vue?vue&type=template&id=31895f3f&lang=pug"
import script from "./ProfileVKEdit.vue?vue&type=script&lang=js"
export * from "./ProfileVKEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__